
import { Directive, HostListener } from '@angular/core';
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { ClapprImplementation } from '@commoncore/implementation/clappr-implementation';
import { DcgroupcodePickerService } from '@commoncore/services/dcgroupcode-picker.service';
import { PingService } from '@commoncore/services/ping.service';
import { ActiveRepo } from '@commoncore/services/universal.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { APP_SETTINGS } from '@mainrepo/app/core/constants/AppSettings';
import { MultiSelectLibrary } from '../utils/MultiSelectUtil';
import { HttpEventType } from '@angular/common/http';
import { Subscription } from 'rxjs';

@Directive()
export class PreviewImplementation {
    public universalService:any;
    public fileForPreview:any;
    public objectsForPreview = [];
    public showPreviewButtons:boolean = true;
    public docType:string = "";
    public docUrl:string="";
    public mediaFiles:boolean = false;
    public audioFiles:boolean = false;
    public videoFiles:boolean = false;
    public listService:any;
    public webUrl: string = "";
    public http: any;
    public previewNotAvailable:boolean = false;
    private togglePreviewButtonsTimer = null;
    private isPreviewOpen = false;
    private displayFactor = 2;
    public contextMenuService:any;
    public clapprImpl: ClapprImplementation;
    // fileOpsService: any;
    public static singleInstance: any = null;
    public router:any;
    cleverTapEventsService: any;

    totalFileCount: number;
    public totatListData:any= 0;
    public audioStopped:boolean = true;
    multiSelect: any;
    searchService:any;
    public onFullScreen:boolean = false;
  customMetadata: any;
  latestPreviewDataArray = [];
  cachedImgPreviewDataArray = [];
  latestPreviewImageUrls = [];
  isNewCache:boolean = false;
  isCacheEnabled:boolean = false;
  containerHeightCalc:any;
  recalculateHeightService:any;
  previewDirection:string="next";
  localStorageService:any;
  pingService: any;
  dcGroupCodePicker: any;
   pdfBlobUrl:any = "";
   downloadSub: Subscription | null = null;

    @HostListener('window:resize', [])resize(){
      var self = this;
      if(!self.universalService.isMobileDevice){
        self.containerHeightCalc.calculateHeight('.tab-content #ag-grid',['.pseudo-header','.pseudo-top-header'],59)
      }else{
        if(this.universalService.virtualGridEnabled) return
        self.containerHeightCalc.calculateHeight('.scrollableContainer',['.pseudo-mobile-header','.pseudo-tab','.pseudo-banner-container', '.pseudo-audiominiplayer'],67)
      }
    }

    private constructor(globalService) {
      this.setHandler(globalService)
    }

    setHandler(globalService){
        // this.fileOpsService = globalService.getFileOperationServiceRef();
        this.http = globalService.getHttpClientRef();
        this.universalService = globalService.getUniversalServiceRef();
        this.contextMenuService = globalService.getContextMenuServiceRef();
        this.listService = globalService.getListServiceRef();
        this.router = globalService.getRouterRef();
        this.clapprImpl = ClapprImplementation.getInstance(globalService);
        this.cleverTapEventsService =  globalService.getCleverTapEventsvc();
        this.multiSelect = MultiSelectLibrary.getInstance(globalService);
        this.searchService = globalService.getSearchServiceRef()
        this.customMetadata = globalService.getCustomMetadataServiceRef();
        this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
        this.recalculateHeightService = this.containerHeightCalc;
        this.localStorageService = globalService.getLocalStorageSvcRef();
        this.pingService = PingService.getInstance(globalService);
        this.dcGroupCodePicker = DcgroupcodePickerService.getInstance(globalService);
    }


    public static getInstance(globalService): PreviewImplementation {
      if (this.singleInstance == null) {
        this.singleInstance = new PreviewImplementation(globalService);
        return this.singleInstance;
      } else {
        return this.singleInstance;
      }
    }
  

    resetValuesBeforeShowingPreview(){
      this.displayFactor = 2;
      this.universalService.openMoreOptions = false;
      this.fileForPreview = "";
      if(this.universalService.showMiniPlayer)
        this.audioStopped = false;
      if(this.universalService.selectedNodes[0]["FullObject"]){
          this.fileForPreview = this.universalService.selectedNodes[0]["FullObject"];
      }else{
          this.fileForPreview = this.universalService.selectedNodes[0];
      }
        this.universalService.selectedFile = this.fileForPreview;
        this.objectsForPreview = this.fetchPreviewArray();

        this.showPreviewButtons = true;
        if(this.fileForPreview != ""){
            this.resetValuesForNextImage();
            this.showPreviewModal(this.fileForPreview);
        }
    }

    fetchPreviewArray(){
      //
        var array = [];
        if((this.universalService.recentFilesDataPreview && !this.universalService.isPreviewFromRecentUpload)||this.router.url.includes("/recents")){
          array = this.universalService.recentFilesPreviewArray;
        }else{
          array = this.universalService.objectsPreviewArray;
        }
        if(this.universalService.listView && !this.universalService.isMobileDevice && this.universalService.selectedTab != "Album Details" && !this.router.url.includes("search")){
          this.totatListData= this.listService.listOptions?.api?.getDisplayedRowCount()
        }
        return array;
      }

    resetValuesForNextImage(){
        this.docType = "";
        this.mediaFiles = false;
        this.audioFiles = false;
        this.videoFiles = false;
        this.pdfBlobUrl = "";
        this.cancelDownload();
        this.universalService.showFileInfo = false;
        AppEvents.optionSelected.next({fileInfo: false});
        var iframe = document.getElementById("pdf-view-container");
        iframe.setAttribute("style","display:none")
        this.previewNotAvailable = false;
        this.universalService.videoPreviewUrl = "";
        if(!this.isCacheEnabled){
          $(".preview_img").attr("src","");
        }
    }


    
  async fetchPrevious() {
    $('#frameholder').addClass('hide');
    var currentIndex;    
    this.universalService.showLoader = true;
    this.resetValuesForNextImage();
    this.objectsForPreview = this.fetchPreviewArray();
    if(this.universalService.selectedFile == undefined){
      this.universalService.selectedFile =  this.fileForPreview;
    }
    var found = this.objectsForPreview.find(file => file["objectKey"] == this.universalService.selectedFile["objectKey"])
    if (found) {
      currentIndex = this.objectsForPreview.indexOf(found);
    } else {

    }
    if (this.fileForPreview["format"] == 'image' || (this.fileForPreview["mimeType"] != 'image' && this.fileForPreview["mimeType"] != 'audio' && this.fileForPreview["mimeType"] != 'video')) {
      this.setPreviousObject(currentIndex)
    } else if(this.fileForPreview["mimeType"] == "audio" || this.fileForPreview["mimeType"] == "video"){
      setTimeout(() => {
        this.setPreviousObject(currentIndex)
      }, 0.1)
    }else {
      this.setPreviousObject(currentIndex)
    }
  }

  setPreviousObject(currentIndex){
    if (currentIndex != -1) {
      if (this.objectsForPreview[currentIndex - 1]) {
        this.universalService.selectedFile = this.objectsForPreview[currentIndex - 1];
        if(this.universalService.selectedFile.isFavorite == "Y"){
          this.universalService.selectedFile.isFavorite = true;
        }else if(this.universalService.selectedFile.isFavorite == "N"){
          this.universalService.selectedFile.isFavorite = false;
        } 
        this.fileForPreview = this.universalService.selectedFile
        this.fileForPreview["showLatestVersion"] = true;
        this.universalService.selectedNodes = [];
        this.universalService.selectedNodes.push(this.universalService.selectedFile)
        if(this.universalService.listView && this.universalService.currentTab=='allfiles' 
            && !this.universalService.isMobileDevice && this.totatListData!=this.objectsForPreview.length ){
          let folderCount= this.totatListData - this.objectsForPreview.length
          this.universalService.x = folderCount+currentIndex-1;
        }
        this.showPreviewModal(this.universalService.selectedFile);
      } else {
        var dataLength = this.objectsForPreview.length;
        this.universalService.selectedFile = this.objectsForPreview[dataLength - 1];
        if(this.universalService.selectedFile.isFavorite == "Y"){
          this.universalService.selectedFile.isFavorite = true;
        }else if(this.universalService.selectedFile.isFavorite == "N"){
          this.universalService.selectedFile.isFavorite = false;
        }
        this.fileForPreview = this.universalService.selectedFile
        this.fileForPreview["showLatestVersion"] = true;
        this.universalService.selectedNodes = [];
        this.universalService.selectedNodes.push(this.universalService.selectedFile)
        if(this.universalService.listView && this.universalService.currentTab=='allfiles' 
          && !this.universalService.isMobileDevice && this.totatListData!=this.objectsForPreview.length){
          let folderCount= this.totatListData - this.objectsForPreview.length
          this.universalService.listIndexOnPreview = folderCount+dataLength-1;
        }
        this.showPreviewModal(this.universalService.selectedFile);
      }
    }
  }

  
  async fetchNext() {
    $('#frameholder').addClass('hide');
    var currentIndex;
    this.universalService.showLoader = true;
    this.resetValuesForNextImage();
    this.objectsForPreview = this.fetchPreviewArray();
    if(this.universalService.selectedFile == undefined){
      this.universalService.selectedFile =  this.fileForPreview;
    }
    var found = this.objectsForPreview.find(file => file["objectKey"] == this.universalService.selectedFile["objectKey"])
    if (found) {
      currentIndex = this.objectsForPreview.indexOf(found);
    } else {

    }
    if (this.fileForPreview["format"] == 'image' || (this.fileForPreview["mimeType"] != 'image' && this.fileForPreview["mimeType"] != 'audio' && this.fileForPreview["mimeType"] != 'video')) {
      this.setNextObject(currentIndex)
    } else if(this.fileForPreview["mimeType"] == "audio" || this.fileForPreview["mimeType"] == "video"){
      setTimeout(() => {
        this.setNextObject(currentIndex)
      }, 0.1)
    }else {
      this.setNextObject(currentIndex)
    }
  }

  setNextObject(currentIndex){
    if (currentIndex != -1) {
      if (this.objectsForPreview[currentIndex + 1]) {
        this.universalService.selectedFile = this.objectsForPreview[currentIndex + 1];
        if(this.universalService.selectedFile.isFavorite == "Y"){
          this.universalService.selectedFile.isFavorite = true;
        }else if(this.universalService.selectedFile.isFavorite == "N"){
          this.universalService.selectedFile.isFavorite = false;
        }
        this.fileForPreview = this.universalService.selectedFile
        this.fileForPreview["showLatestVersion"] = true;
        this.universalService.selectedNodes = [];
        this.universalService.selectedNodes.push(this.universalService.selectedFile)
        if(this.universalService.listView && this.universalService.currentTab=='allfiles' 
          && !this.universalService.isMobileDevice && this.totatListData!=this.objectsForPreview.length){
          let folderCount= this.totatListData - this.objectsForPreview.length
          this.universalService.listIndexOnPreview = folderCount+currentIndex+1;
        }
        this.showPreviewModal(this.universalService.selectedFile);
      } else {
        this.universalService.selectedFile = this.objectsForPreview[0];
        if(this.universalService.selectedFile.isFavorite == "Y"){
          this.universalService.selectedFile.isFavorite = true;
        }else if(this.universalService.selectedFile.isFavorite == "N"){
          this.universalService.selectedFile.isFavorite = false;
        }
        this.fileForPreview = this.universalService.selectedFile
        this.fileForPreview["showLatestVersion"] = true;
        this.universalService.selectedNodes = [];
        this.universalService.selectedNodes.push(this.universalService.selectedFile)
        if(this.universalService.listView && this.universalService.currentTab=='allfiles' 
          && !this.universalService.isMobileDevice && this.totatListData!=this.objectsForPreview.length){
          let folderCount= this.totatListData - this.objectsForPreview.length
          this.universalService.listIndexOnPreview = folderCount;
        }
        this.showPreviewModal(this.universalService.selectedFile);

      }
    }else{
      
    } 
  }

  


  

  async showPreviewModal(file) {
    if(this.universalService.activeRepo == ActiveRepo.INVITE){
      file["previewTranscodeUrl"] = file["imageTranscodeUrl"]
    }
    if(this.fileForPreview["recalculation"] == true){
      this.fileForPreview["recalculation"] = false
      this.fileForPreview["height"] = undefined
      this.fileForPreview["width"] = undefined
    }
    if (file.mimeType == 'audio' || (this.fileForPreview["mimeType"] != 'image' && this.fileForPreview["mimeType"] != 'audio' && this.fileForPreview["mimeType"] != 'video')) {
      if(document.fullscreen || (document as any).webkitIsFullScreen) {
        document.exitFullscreen();
      }
    }
    if(this.universalService.isUnFavInvoked){ 
      let currentPos = this.universalService.selectedPreviewFileIndex -1;
      this.universalService.objectsPreviewArray.splice(currentPos,1)
      this.universalService.isUnFavInvoked = false;
    }
    this.universalService.isMobileTopMoreOptionMenu = false;
    this.universalService.selectedPreviewFile = file;
    this.previewNotAvailable = false;
    this.universalService.showMobOptionMenu = false;
    this.latestPreviewImageUrls = [];
    var found = this.objectsForPreview.find(file => file["objectKey"] == this.universalService.selectedFile["objectKey"])
    if (found) {
      this.universalService.selectedPreviewFileIndex =  this.objectsForPreview.indexOf(found)+1;
    }
    
    this.universalService.isMobileFilePreviewOpen = true;

    if(file["fromSearchSugg"]){
      this.isCacheEnabled = false;
      delete file["fromSearchSugg"];
      var fileFound = this.universalService.objectsPreviewArray.find(obj=>obj["objectKey"] == file["objectKey"]);
      if(fileFound){
        var index = this.universalService.objectsPreviewArray.indexOf(fileFound);
        this.universalService.objectsPreviewArray.splice(index,1);
        this.objectsForPreview = this.universalService.objectsPreviewArray;
        this.universalService.selectedFile = file;
        this.fileForPreview = file;
      }
    }else if(file["previewFromUpload"]){
      this.isCacheEnabled = false;
    }else if(!this.universalService.containsOnlyPhotos){
      this.isCacheEnabled = true;
      this.checkIfEnableCaching(file);
    }else if(this.objectsForPreview.length >= 5 && (this.universalService.currentTab == "photos"|| this.universalService.currentTab == "Person Details") && this.universalService.containsOnlyPhotos) {
      this.isCacheEnabled = true;
      this.getLatestPreviewData(file, this.universalService.selectedPreviewFileIndex);
    } else if(this.objectsForPreview.length < 5 && (this.universalService.currentTab == "Person Details")) {
      this.isCacheEnabled = false;
    }
    

    // else {
    //   this.isCacheEnabled = false;
    // }
    await this.clculateTotalfileCount()
      if(this.fileForPreview["mimeType"] == "image" || this.fileForPreview["mimeType"] == "video"){

        if(this.fileForPreview["mimeType"]=="video"){
          if((((parseInt(this.fileForPreview["height"])<300) ))){
            this.fileForPreview["height"] = "400";
          }
          if((parseInt(this.fileForPreview["width"])<300)){
            this.fileForPreview["width"] = "500";
          }
          this.mediaFiles = true;
          this.videoFiles = true;
          if(this.universalService.player!=undefined && this.universalService.player!=null){
            this.universalService.player.stop();
            this.universalService.player.destroy();
          }
          this.universalService.showMiniPlayer = false;
          if(this.universalService.isMobileDevice){
            setTimeout(()=>{
              let height = window.innerHeight - 60;
              (document.querySelector('#video-media-content .video-container')as any).style.height = height+'px'
            },400)
          }
        }

        if (!this.isPreviewOpen) {
          this.isPreviewOpen = true;
          this.togglePreviewButtons();
        }

        var size = 'f';
        if (screen.width > 1024) {
          size = 'f';
        } else {
          size = 'n';
        }
      if (this.fileForPreview["top"] != undefined && this.fileForPreview["left"] != undefined) {
        var dimensions = {
          'imageWidth': this.fileForPreview["imageWidth"],
          'imageHeight': this.fileForPreview["imageHeight"]
        };
        this.getImageUrl(dimensions, this.fileForPreview);
        this.fileForPreview["imageUrl"]= this.webUrl;
        this.addAnimationToImageWhileRendering();
        this.universalService.videoPreviewUrl = this.fileForPreview;
      } else {
      //  this.universalService.showLoader = true;
        if (this.isCacheEnabled == false || this.fileForPreview["mimeType"] == "video") {
          await this.getImageSize(file);
        }
        
        //this.universalService.showLoader = false;
      }

      if (this.isCacheEnabled == true && this.fileForPreview["mimeType"] == "image" && this.universalService.containsOnlyPhotos) {
        this.cacheObjects();
      } else {
        this.fileForPreview["imageUrl"]= this.webUrl; 
      }

      // if(this.fileForPreview["mimeType"] == 'video' && this.universalService.onFullScreen){
      //   setTimeout(() => {
      //     $('#video-media-content [data-player]').css("left",0);
      //     // AppEvents.emit("FULLSCREEN")
      //   }, 500);
      // }
      
    }else if (this.fileForPreview["mimeType"] == "audio"){
      //this.universalService.showLoader = false;
      //ON audio tab, if audio is already playing and restart on click

      if(this.clapprImpl.audioplayer && !this.audioStopped) {
        this.universalService.showMiniPlayer = false;
        this.clapprImpl.pauseAudio();
        this.clapprImpl.audioplayer.stop();
        this.clapprImpl.audioplayer.destroy();
        if(!this.universalService.player){
          this.audioStopped = true;
        }
      }

      if(this.universalService.player && !this.audioStopped) {
       
        this.universalService.showMiniPlayer = false;
        this.universalService.player.pause();
        this.universalService.player.stop();
        this.universalService.player.destroy();
        this.audioStopped = true;
      }
      this.mediaFiles = true;
      this.audioFiles = true;
      if(!this.universalService.isMobileDevice && this.universalService.activeRepo == 'main' && (this.universalService.currentTab == 'audio' || this.universalService.showFullViewAudioPlayer)){
        this.universalService.audioPreview = true;
        setTimeout(() => {
          this.listService.audioPreviewOptions.api.setRowData(this.listService.rowData);
        //  this.universalService.showLoader = false;
        }, 500);
        
      }
      
      if(this.universalService.isMobileDevice && this.universalService.activeRepo == 'main' && this.universalService.currentTab == 'audio'){
        this.universalService.showMiniPlayer = false;
        this.universalService.showAudioPreviewForFilter = true;
        this.universalService.showAudioWaves = true;
      }else{
        this.universalService.showAudioPreviewForFilter = false;
        if(!this.universalService.isMobileDevice && this.universalService.currentTab == 'audio' && this.universalService.activeRepo == 'main'){
          this.universalService.showAudioWaves = true;
        }else{
          this.universalService.showAudioWaves = false;
        }
      }
      if (!this.isPreviewOpen) {
        this.isPreviewOpen = true;
        this.togglePreviewButtons();
      }
    }else {

      if (!this.isPreviewOpen) {
        this.isPreviewOpen = true;
        jQuery("#preview-modal").focus();
      }
      
      if(window.location.href.indexOf('people')<0){
        await this.checkDocType(this.fileForPreview);
      }
      
    }
    var extns = this.fileForPreview["objectName"].split(".");
    this.contextMenuService.decideContextMenuItems();
    this.universalService.showLoader = (extns.length > 1 && extns[extns.length - 1]  == 'pdf')?true:false;
    console.log("this.universalService.showLoader::",this.universalService.showLoader);
    this.togglePreviewButtons();
    this.cleverTapEventsService.repoFileViewed(file, this.universalService.currentTab);
  }

  async editDocuments(file,result){
    $('#docditform').attr('action', result.url);
    // $("#shardkey").remove();
    $("#objkey").remove();
    $("#accesstoken").remove();
    $("#tokenTimeout").remove();
    $("#user_id").remove();
    $("#owner_id").remove();
    // $('<input id="shardkey" type="hidden" name="shard_key"/>').val("").val($scope.shardKey).appendTo('#docditform');
    $('<input id="objkey" type="hidden" name="object_key"/>').val("").val(file.objectKey).appendTo('#docditform');
    $('<input id="accesstoken" type="hidden" name="access_token"/>').val("").val(result.accessToken).appendTo('#docditform');
    $('<input id="tokenTimeout" type="hidden" name="access_token_ttl"/>').val("").val(result.accessTTL).appendTo('#docditform');
    $('<input id="user_id" type="hidden" name="user_id"/>').val("").val(result.userId).appendTo('#docditform');
    $('<input id="owner_id" type="hidden" name="owner_id"/>').val("").val(result.ownerId).appendTo('#docditform');
    $("#docditform").submit();
    $('#frameholder').removeClass('hide');
    setTimeout(() => {
      var b1 = document.querySelector("#fileName") as HTMLElement
      b1?.click();
    },10);
  }
  clculateTotalfileCount(){
    this.universalService.priviewFileCount = 0;
    //
    if(this.universalService.recentFilesDataPreview){
      this.universalService.priviewFileCount  = this.objectsForPreview.length
    }else{
      this.universalService.priviewFileCount  = this.objectsForPreview.length

    }
  }
  async checkDocType(file){
    var extns = this.fileForPreview["objectName"].split(".");
    this.docType = extns[extns.length - 1];
    
    this.docUrl = this.fileForPreview["url"]
    
    if(this.docType == 'pdf'){
      if(this.universalService.inAppWebViewOpened){ // in the in app webview we were asked to open the preview of PDF with default tile.
        this.previewNotAvailable = true;
        return
      }
      if(this.universalService.currentTab == 'PrivateFolder'){
        await this.listService.getPPFToken();    
        this.universalService.isPrivateFolderTokenRequired = true;
      }
      /*if(this.universalService.isMobileDevice){
       // this.closePreview();
        if(this.universalService.currentTab == 'PrivateFolder'){
          window.open(this.docUrl + "&pdfrender=y&ppftoken="+encodeURIComponent(this.universalService.header_X_PPF_TOKEN), "_system", "noopener, noreferrer");
        }else{
          var url = this.docUrl + "&pdfrender=y"
          var eleContainer = document.getElementById('pdf-view-container');
          var ele = document.getElementById('pdfview');
          eleContainer.setAttribute("style","display:block")
          setTimeout(() => {
            this.loadPdfFromUrl(url);
          }, 2000);
          //window.open(this.docUrl + "&pdfrender=y", "_system", "noopener, noreferrer");
        }
      }else{*/
        var url = this.docUrl + "&pdfrender=y"
        if(this.universalService.currentTab == 'PrivateFolder'){
          url = url +  "&ppftoken="+encodeURIComponent(this.universalService.header_X_PPF_TOKEN);
        }
    //    let cookieHeader = "appSecret_jc="+ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-App-Secret"]+"&ulk_"+this.sessionStorageService.getUnivShareLinkShareKey()+this.sessionStorageService.getUnivShareLinkSessionID()

        var eleContainer = document.getElementById('pdf-view-container');
        var ele = document.getElementById('pdfview');
        eleContainer.setAttribute("style","display:block")
        setTimeout(() => {
          this.universalService.showLoader = true;
          this.loadPdfFromUrl(url);
        }, 2000);
/*
        ele.setAttribute('src',url + "#toolbar=0&navpanes=0&scrollbar=0");
        ele.setAttribute("height","100%");
        ele.setAttribute("width","100%");
        setTimeout(()=>{
          var toolbarEle = document.getElementById('toolbarContainer');
          if(toolbarEle){
            toolbarEle.style.display = "none";
          }
        },500)*/
     // }
      
    }else if((!this.fileForPreview["libreOfficeSupported"] && !this.fileForPreview["OfficeForWebSupported"]) || (this.universalService.activeRepo == ActiveRepo.SHARE)){
      this.previewNotAvailable = true;
    }
  }  
  
  loadPdfFromUrl(url){
    this.downloadSub = this.http.get(url, {withCredentials: true, responseType: 'blob',observe: 'events',reportProgress: true}).subscribe(
      async event => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percent = Math.round((100 * event.loaded) / (event.total || 1));
          console.log("Downloaded:",percent);
        }
        if (event.type === HttpEventType.Response) {
          console.log("HttpEventType.Response::",HttpEventType.Response);
          const blob = event.body!;
          this.pdfBlobUrl = await URL.createObjectURL(blob); // create a blob URL
          this.universalService.showLoader = false;
          this.downloadSub = null;
        }
        
      },
      async error => {
        this.universalService.showLoader = false;
        this.downloadSub = null;
       if (error.error instanceof Blob) {
          const text = await error.error.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          const scriptTags = doc.querySelectorAll('script');
          scriptTags.forEach((scriptTag) => {
            // Get the content of the script tag
            const scriptContent = scriptTag.textContent?.trim();
            if (scriptContent) {
              eval(scriptContent);
              //scriptContents.push(scriptContent);
            }
          });
        }
      }
    );
  }

  cancelDownload() {
    if (this.downloadSub) {
      this.downloadSub.unsubscribe();
      this.downloadSub = null;
    }
  }

  setPositionForMobileDevice(file) {
    var orientation = null;
    var rawFile = Object.assign({}, this.fileForPreview);
    var availableHeight = window.innerHeight;
    var availableWidth = window.innerWidth;
    var sizeParameter = undefined;
    var imageHeight = undefined;
    var imageWidth = undefined;
    
    // if (!this.universalService.showJustifiedLayout) {
      if (!rawFile.inverted && rawFile.orientation != undefined && (rawFile.orientation.indexOf("90") != -1 || rawFile.orientation.indexOf("270") != -1)) {
        this.fileForPreview["width"] = rawFile.height;
        this.fileForPreview["height"] = rawFile.width;
        this.fileForPreview["inverted"] = true;
      }
    // }

    if (parseInt(this.fileForPreview["height"]) > parseInt(this.fileForPreview["width"])) { //potrait image
      orientation = "potrait";
      var ratio = this.fileForPreview["height"] / this.fileForPreview["width"];

      if (this.fileForPreview["width"] < availableWidth && this.fileForPreview["height"] < availableHeight) {
        if(this.fileForPreview["mimeType"]=="video"){
          imageWidth = this.fileForPreview["width"];
          imageHeight = availableHeight-120;
          }else{
          imageWidth = this.fileForPreview["width"];
          imageHeight = this.fileForPreview["height"];
          }
      } else if (this.fileForPreview["width"] < availableWidth && this.fileForPreview["height"] >= availableHeight) {
        if(this.fileForPreview["mimeType"]=="video"){
        imageWidth = this.fileForPreview["width"];
        imageHeight = availableHeight-120;
        }else{
        imageWidth = this.fileForPreview["width"]
        imageHeight = availableHeight;
        }
      } else {
        if(this.fileForPreview["mimeType"]=="video"){
        imageWidth = availableWidth;
        imageHeight = (availableHeight)-120;
        }else{
        imageWidth = availableWidth;
        imageHeight = availableWidth * ratio;
        }
      }

      var remainingWidth = availableWidth - imageWidth;
      var remainingHeight = availableHeight - imageHeight;

      if (remainingHeight < 0) {
        remainingHeight = 0;
      }

      this.fileForPreview["top"] = remainingHeight / 2;
      this.fileForPreview["left"] = remainingWidth / 2;
      this.universalService.selectedFile["top"] = this.fileForPreview["top"];
      this.universalService.selectedFile["left"] = this.fileForPreview["left"]

    } else {
      orientation = "landscape";

      var ratio = this.fileForPreview["width"] / this.fileForPreview["height"];

      if (this.fileForPreview["width"] < availableWidth && this.fileForPreview["height"] < availableHeight) {
        if(this.fileForPreview["mimeType"]=="video"){
          imageWidth = this.fileForPreview["width"];
          imageHeight = availableHeight-120;
          }else{
        imageWidth = this.fileForPreview["width"];
        imageHeight = this.fileForPreview["height"];
          }
      } else if (this.fileForPreview["width"] < availableWidth && this.fileForPreview["height"] >= availableHeight) {
        if(this.fileForPreview["mimeType"]=="video"){
          imageWidth = this.fileForPreview["width"];
          imageHeight = availableHeight-120;
          }else{
        imageWidth = this.fileForPreview["width"];
        imageHeight = availableHeight;
          }
      } else {
        // if(this.fileForPreview["mimeType"]=="video"){
        //   imageWidth = this.fileForPreview["width"];
        //   imageHeight = availableHeight-120;
        //   }else{
          imageWidth = availableWidth;
          imageHeight = imageWidth / ratio;
          // }
      }

      var remainingWidth = availableWidth - imageWidth;
      var remainingHeight = availableHeight - imageHeight;

      this.fileForPreview["top"] = remainingHeight / 2;
      this.fileForPreview["left"] = remainingWidth / 2;
      this.universalService.selectedFile["top"] = this.fileForPreview["top"];
      this.universalService.selectedFile["left"] = this.fileForPreview["left"]
    }
    return {
      "imageWidth": Math.round(imageWidth),
      "imageHeight": Math.round(imageHeight)
    };
  };

  setPositionForDesktop(file) {
    var orientation = null;
    var rawFile = Object.assign({}, file);
    var availableHeight = window.innerHeight;
    var availableWidth = window.innerWidth;
    var sizeParameter = undefined;
    var imageHeight = undefined;
    var imageWidth = undefined;


    // if(!this.universalService.showJustifiedLayout){
      if (!rawFile["inverted"] && rawFile.orientation != undefined && (rawFile.orientation.indexOf("90") != -1 || rawFile.orientation.indexOf("270") != -1)) {
        this.fileForPreview["width"] = rawFile.height;
        this.fileForPreview["height"] = rawFile.width;
        this.fileForPreview["inverted"] = true;
      }
    // }
    

    if (parseInt(this.fileForPreview["height"]) > parseInt(this.fileForPreview["width"])) { //potrait image
      orientation = "potrait";
      var ratio = this.fileForPreview["height"] / this.fileForPreview["width"];
      if (this.fileForPreview["height"] < availableHeight && this.fileForPreview["width"] < availableWidth) {
        if(this.fileForPreview["mimeType"]=="video"){
          imageHeight = availableHeight-120;
          imageWidth = imageHeight / ratio;
        }else{
        imageWidth = this.fileForPreview["width"];
        imageHeight = this.fileForPreview["height"];
        }
      } else if (this.fileForPreview["height"] >= availableHeight) {
        if(this.fileForPreview["mimeType"]=="video"){
          imageHeight = availableHeight-120;
          imageWidth = imageHeight / ratio;
        }else{
          imageHeight = availableHeight;
          imageWidth = imageHeight / ratio;
        }
      }
      var remainingWidth = availableWidth - imageWidth;
      var remainingHeight = availableHeight - imageHeight;

      this.fileForPreview["top"] = remainingHeight / 2;
      this.fileForPreview["left"] = remainingWidth / 2;
      this.universalService.selectedFile["top"] = this.fileForPreview["top"];
      this.universalService.selectedFile["left"] = this.fileForPreview["left"]
    } else {
      orientation = "landscape";

      var ratio = this.fileForPreview["width"] / this.fileForPreview["height"];

      if (this.fileForPreview["width"] < availableWidth && this.fileForPreview["height"] < availableHeight) {
        if(this.fileForPreview["mimeType"]=="video"){
          imageHeight = availableHeight-120;
          imageWidth = imageHeight * ratio;
        }
        else{
        imageWidth = this.fileForPreview["width"];
        imageHeight = this.fileForPreview["height"];
        }
      } else if (this.fileForPreview["height"] > availableHeight) {
        if(this.fileForPreview["mimeType"]=="video"){
        imageHeight = availableHeight-120;
        imageWidth = imageHeight * ratio;
        }else{
        imageHeight = availableHeight;
        imageWidth = imageHeight * ratio;
        }
      } else {
        if(this.fileForPreview["mimeType"]=="video" && this.fileForPreview["height"] == availableHeight){
        imageWidth = availableWidth;
        imageHeight = (imageWidth / ratio)-120;
        }else{
        imageWidth = availableWidth;
        imageHeight = imageWidth / ratio;
        }
      }
      
      var remainingWidth = availableWidth - imageWidth;
      var remainingHeight = availableHeight - imageHeight;
      

      this.fileForPreview["top"] = remainingHeight / 2;
      this.fileForPreview["left"] = remainingWidth / 2;
      this.universalService.selectedFile["top"] = this.fileForPreview["top"];
      this.universalService.selectedFile["left"] = this.fileForPreview["left"];

    }
    return {
      "imageWidth": Math.round(imageWidth),
      "imageHeight": Math.round(imageHeight)
    };
  }

  getImageSize(file) {
    var availableHeight = window.innerHeight;
    var availableWidth = window.innerWidth;

    if (availableWidth < 767) { //it will be mobile device
      if ((this.fileForPreview["height"] == undefined || this.fileForPreview["width"] == undefined)) {
        var img = new Image();
        var size = 'n';
        this.webUrl = this.fileForPreview["previewTranscodeUrl"];
        this.webUrl = this.webUrl.includes("?") ? this.webUrl + "&" : this.webUrl + "?";
        let type = this.universalService.checkIfImgTypeParamIsRequired(file["mimeSubType"]);
        this.webUrl = this.webUrl + "size=" + size + "&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
        img.src = this.webUrl;
        this.fileForPreview["imageUrl"] = this.webUrl;
        img.onload = (event) => {
          this.fileForPreview["height"] = img.height;
          this.fileForPreview["width"] = img.width;
          var imageDim = this.setPositionForMobileDevice(file);
          var dimensions = {
            'imageWidth': imageDim.imageWidth,
            'imageHeight': imageDim.imageHeight
          };
          this.fileForPreview["imageHeight"] = imageDim.imageHeight;
          this.fileForPreview["imageWidth"] = imageDim.imageWidth;
          this.universalService.selectedFile["imageHeight"] = this.fileForPreview["imageHeight"];
          this.universalService.selectedFile["imageWidth"] = this.fileForPreview["imageWidth"]
          this.getImageUrl(dimensions, file);
          this.fileForPreview["imageUrl"] = this.webUrl;
          this.addAnimationToImageWhileRendering();
          this.universalService.videoPreviewUrl = this.fileForPreview;
        };
      } else {
        imageDim = this.setPositionForMobileDevice(file);
        var dimensions = {
          'imageWidth': imageDim.imageWidth,
          'imageHeight': imageDim.imageHeight
        };
        this.fileForPreview["imageHeight"] = imageDim.imageHeight;
        this.fileForPreview["imageWidth"] = imageDim.imageWidth;
        this.universalService.selectedFile["imageHeight"] = this.fileForPreview["imageHeight"];
        this.universalService.selectedFile["imageWidth"] = this.fileForPreview["imageWidth"]
        this.getImageUrl(dimensions, file);
        this.fileForPreview["imageUrl"] = this.webUrl;
        this.addAnimationToImageWhileRendering();
        this.universalService.videoPreviewUrl = this.fileForPreview;
      } 
    }else {
      if ((this.fileForPreview["height"] == undefined || this.fileForPreview["width"] == undefined)) {
        var img = new Image();

        var size = 'f';
        this.webUrl = this.fileForPreview["previewTranscodeUrl"];
        this.webUrl = this.webUrl.includes("?") ? this.webUrl + "&" : this.webUrl + "?";
        let type = this.universalService.checkIfImgTypeParamIsRequired(file["mimeSubType"]);
        this.webUrl = this.webUrl + "size=" + size + "&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
        img.src = this.webUrl;
        this.fileForPreview["imageUrl"] = this.webUrl;
        var imageDim;
        img.onload = (event) => {
          this.fileForPreview["height"] = img.height;
          this.fileForPreview["width"]= img.width;

          imageDim = this.setPositionForDesktop(file);
          var dimensions = {
            'imageWidth': imageDim.imageWidth,
            'imageHeight': imageDim.imageHeight
          };

          this.fileForPreview["imageHeight"] = imageDim.imageHeight;
          this.fileForPreview["imageWidth"] = imageDim.imageWidth;
          this.universalService.selectedFile["imageHeight"] = this.fileForPreview["imageHeight"];
          this.universalService.selectedFile["imageWidth"] = this.fileForPreview["imageWidth"]
          this.getImageUrl(dimensions, file);
          this.fileForPreview["imageUrl"]= this.webUrl;
          this.addAnimationToImageWhileRendering();
          this.universalService.videoPreviewUrl = this.fileForPreview;
        };
      } else {
        imageDim = this.setPositionForDesktop(file);
        var dimensions = {
          'imageWidth': imageDim.imageWidth,
          'imageHeight': imageDim.imageHeight
        };
        this.fileForPreview["imageHeight"] = imageDim.imageHeight;
        this.fileForPreview["imageWidth"] = imageDim.imageWidth;
        this.universalService.selectedFile["imageHeight"] = this.fileForPreview["imageHeight"];
        this.universalService.selectedFile["imageWidth"] = this.fileForPreview["imageWidth"]
        this.getImageUrl(dimensions, file);
        this.fileForPreview["imageUrl"]= this.webUrl;
        this.addAnimationToImageWhileRendering();
        this.universalService.videoPreviewUrl = this.fileForPreview;
      }
    }
  }

  getImageUrl(dimensions, file) {
    this.webUrl = this.fileForPreview["previewTranscodeUrl"];
    this.webUrl = this.webUrl.includes("?") ? this.webUrl + "&" : this.webUrl + "?";
    if (this.fileForPreview["mimeSubType"] != 'gif') {
      let type = this.universalService.checkIfImgTypeParamIsRequired(this.fileForPreview["mimeSubType"]);
      this.webUrl = this.webUrl + "size=v&height=" + dimensions.imageHeight * this.displayFactor + "&width=" + dimensions.imageWidth * this.displayFactor + "&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
    } 
    if (this.fileForPreview["mimeSubType"] == 'gif') {
      let type = this.universalService.checkIfImgTypeParamIsRequired(this.fileForPreview["mimeSubType"]);
      this.webUrl = this.webUrl + "apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
    }
    // this.webUrl = this.webUrl.split(".com")[1];
  }

  addAnimationToImageWhileRendering(){
    if(this.universalService.onFullScreen) return;
    $(".preview_img").removeClass('slideFromLeftToRight')
    $(".preview_img").removeClass('slideFromRightToLeft')
    setTimeout(() => {
      if(this.previewDirection == "next"){
        $(".preview_img").removeClass('slideFromLeftToRight')
        $(".preview_img").addClass('slideFromRightToLeft');
      }else{
        $(".preview_img").removeClass('slideFromRightToLeft')
        $(".preview_img").addClass('slideFromLeftToRight');
      }
    }, 5);
  }
  closePreview() {
    var self = this;

    this.universalService.hideDeleteForPublicPreviewShare = false;
    //following line is added as for prelogin leftMenu is initially hidden for better experience, now on closing file preview, left menu should be shown.
    if(this.universalService.activeRepo == 'share'){
      if(this.universalService.hideLeftMenu){
        this.universalService.hideLeftMenu = false;
      }
      else{
        var el = document.getElementById("libLeftMenu");
        if(el!=null){
          el.style.opacity = '1';
        }
      }
    }


    var mediaStreamTokenTimeLS = this.localStorageService.getItem(LocalStorageProps.MEDIA_STREAM_TOKEN_TIME + '_' + this.universalService.selectedFile.objectKey);
    if(mediaStreamTokenTimeLS != null) {
      this.localStorageService.removeItem(LocalStorageProps.MEDIA_STREAM_TOKEN_TIME + '_' + this.universalService.selectedFile.objectKey);
    }
    
    this.universalService.showPreview = false;
    this.universalService.showMobFileInfoPanel = false;
    this.universalService.isMobileFilePreviewOpen = false;
    this.universalService.showFileInfo = false;
    AppEvents.optionSelected.next({fileInfo: false});
    this.universalService.selectedFile = "";
    this.listService.deSelectAll(null);
    this.pingService.clearInterval(); // clears the ping interval for which is started when the video preview is open
    this.universalService.selectedNodes = [];
    this.listService.cellclick = false;
    this.universalService.showLoader = false;
    this.universalService.isServerError = false;
    this.universalService.recentFilesDataPreview = false;
    this.universalService.showAudioPreviewForFilter = false;
    var closingPreviewFileType = this.fileForPreview.mimeType;
    this.fileForPreview = "";
    this.isPreviewOpen = false
    this.universalService.isManualVideoPause = false;
    jQuery(".grid_info").removeClass("grid_info");
    this.universalService.contextMenuOptions = [];
    if(this.universalService.showFullViewAudioPlayer) {
      this.universalService.showFullViewAudioPlayer = false;
    }
    if(this.universalService.currentTab == 'audio' && this.universalService.activeRepo == 'main' && this.universalService.selectedTab != 'Album Details' && closingPreviewFileType == "audio"){
      if(!this.universalService.isMobileDevice){
        if(this.listService.listOptions.api["columnModel"]["columnDefs"].length == 0){
          this.listService.setHeaderHeight(60);
          this.listService.listOptions.api.setGridOption('columnDefs', this.listService.audioDefs);
          this.listService.listOptions.api.sizeColumnsToFit();
        }
        setTimeout(function() {
          self.listService.listOptions.api.setRowData(self.listService.rowData);
        }, 500);
        this.containerHeightCalc.calculateHeight('.tab-content #ag-grid',['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'],59)
      }else{
        this.multiSelect.bindMultiSelectLibrary("#audioWrapperId", "list_info", ".listItem:visible", false,this.universalService.virtualGridEnabled,false);
        this.multiSelect.bindMultiSelectUIevent(".main-wrapper", ".list_file_child");
        AppEvents.multiSelectEvent.next({"dataArray":this.universalService.mobilePlayList});
      }
      this.universalService.showFullViewAudioPlayer = false;
      this.universalService.showLoader = false;
      this.universalService.audioPreview = false;
      this.universalService.showMiniPlayer = true;
    }else if (this.universalService.currentTab != 'audio' && this.fileForPreview["mimeType"] == 'audio'){
      this.universalService.showMiniPlayer = false;
    }else{
      if(this.universalService.selectedTab == 'Album Details' || this.universalService.isPreviewFromRecentUpload == true) {
        this.clearPreviewCache();
        this.universalService.isPreviewFromRecentUpload = false;
      }
      //this.universalService.showMiniPlayer = false;
      this.universalService.audioPreview = false
      this.universalService.showFullViewAudioPlayer = false;
    }
    // else {
    //   this.universalService.showMiniPlayer = false;
    //   this.universalService.showFullViewAudioPlayer = true;
    // }

    if(this.universalService.isPreviewOpenFromSearchDropdown && this.universalService.isMobileDevice){
      this.searchService.openAutoSearch.next(true)
    }
    this.universalService.isPreviewOpenFromSearchDropdown = false
    this.universalService.atPreviewfolderCount = 0;
    if(this.universalService.showMiniPlayer == false){
      this.universalService.isStreaming = false;
    }
    this.cancelDownload();
    if(this.clapprImpl.videoPlayer != undefined) {
      this.clapprImpl.videoPlayer.destroy();
    }
    if(this.clapprImpl.audioplayer != undefined && !this.router.url.includes("/audio")) {
      this.clapprImpl.audioplayer.destroy();
    }
    setTimeout(() => {
      this.recalculateHeightService.sendRecalculateEventToComponents(true,{ignoreReAdjustingVHinVirtualGrid:true});
    }, 800);
  }
  togglePreviewButtons() {
    var classRef = this;
    clearTimeout(classRef.togglePreviewButtonsTimer);
    classRef.togglePreviewButtonsTimer = null;
    jQuery("#preview-modal .modal-header").fadeIn();
    jQuery("#preview-modal .modal-footer").fadeIn();

    jQuery("#preview-modal .previousIcon").fadeIn();
    jQuery("#preview-modal .nextIcon").fadeIn();

    classRef.togglePreviewButtonsTimer = setTimeout(function() {
      jQuery("#preview-modal .modal-header").fadeOut();
      jQuery("#preview-modal .modal-footer").fadeOut();
      jQuery("#preview-modal .previousIcon").fadeOut();
      jQuery("#preview-modal .nextIcon").fadeOut();
      if(!classRef.universalService.isMobileDevice){
        classRef.universalService.openMoreOptions = false;
        classRef.universalService.openMoreOptionsContextMenu = false;
      }
      $("#preview-modal").unbind().bind('click', function() {
        if ($("#shareView .prvw_bnr").is(':visible')) {
          jQuery("#preview-modal .modal-header").fadeOut();
          jQuery("#preview-modal .modal-footer").fadeOut();
          jQuery("#preview-modal .previousIcon").fadeOut();
          jQuery("#preview-modal .nextIcon").fadeOut();
          clearTimeout(classRef.togglePreviewButtonsTimer);
          classRef.togglePreviewButtonsTimer = null;
        } else {
          jQuery("#preview-modal .modal-header").fadeIn();
          jQuery("#preview-modal .modal-footer").fadeIn();
          jQuery("#preview-modal .previousIcon").fadeIn();
          jQuery("#preview-modal .nextIcon").fadeIn();
          classRef.togglePreviewButtons();
        }
      });
      // if ($(window).width() > 767) {
        $("#preview-modal").bind('mousemove', function() {
          jQuery("#preview-modal .modal-header").fadeIn();
          jQuery("#preview-modal .modal-footer").fadeIn();
          jQuery("#preview-modal .previousIcon").fadeIn();
          jQuery("#preview-modal .nextIcon").fadeIn();
          classRef.togglePreviewButtons();
        });
      // }

    }, 8000);
  }

  async deleteORMoveObject(action,semanticPreviewFromHorizontalPanel=false){  
    this.resetValuesForNextImage()

    if(this.universalService.isPreviewOpenFromSearchDropdown || this.universalService.selectedFile["previewFromUpload"]){
      this.closePreview();
      return;
    }
    //this.objectsForPreview = await this.fetchPreviewArray();
    let nextIndex;
    let currentIndex;
    if(!this.universalService.isMobileDevice && this.universalService.activeRepo == 'main' && this.universalService.currentTab == 'audio')
        currentIndex=this.universalService.audioListIndexOnPreview
    else
        currentIndex= this.universalService.selectedPreviewFileIndex-1 
    if(this.universalService.currentTab == 'Home' && this.universalService.recentFilesDataPreview && !this.universalService.fetchAllRecentFiles){  
      this.objectsForPreview = await this.fetchPreviewArray();/** to fetch updated recent list */
      if(action=='TRASH' || action=='FTR' )
      if(currentIndex < 0){
        currentIndex=currentIndex+1;
      }
      if(currentIndex >= this.objectsForPreview.length -1)
        nextIndex=0
      else
        nextIndex=currentIndex+1
      //this.objectsForPreview.splice(currentIndex, 1);
      this.checkVideoClapper();
      this.universalService.selectedFile = this.objectsForPreview[nextIndex];
      this.universalService.selectedNodes = [];
      this.universalService.selectedNodes.push(this.universalService.selectedFile)
      this.fileForPreview = this.objectsForPreview[nextIndex];
      if(this.objectsForPreview.length == 0){
        this.universalService.showPreview = false
      }else{
        this.showPreviewModal(this.objectsForPreview[nextIndex]) 
      }
    }else if(this.universalService.currentTab == 'allfiles' && this.universalService.recentFilesDataPreview && this.universalService.fetchAllRecentFiles){ 
      let recentDataArrayLength = this.universalService.recentFilesPreviewArray.length
      if(action == 'TRASH' || action == 'FTR' || action == 'MOVE')
        this.universalService.recentFilesPreviewArray.splice(currentIndex, 1);
   
      this.objectsForPreview = await this.fetchPreviewArray();/** to fetch updated recent list */

      if(
        (action == 'TRASH' && currentIndex > recentDataArrayLength-1)
        ||(action == 'MOVE' && currentIndex == recentDataArrayLength-1)
        )
        nextIndex=0
      else
        nextIndex=currentIndex
        
      this.checkVideoClapper();
      
      this.universalService.selectedFile = this.objectsForPreview[nextIndex];
      this.universalService.selectedNodes = [];
      this.universalService.selectedNodes.push(this.universalService.selectedFile)
      this.fileForPreview = this.universalService.selectedFile;

      if(this.objectsForPreview.length == 0){
        this.universalService.showPreview = false
      }else{
        this.showPreviewModal(this.universalService.selectedFile)   
      }
      
    }else if(action == 'TRASH' || action == 'FTR' || action == 'MOVETOPF'  || ((this.universalService.currentTab == 'allfiles' || this.universalService.currentTab == "PrivateFolder") && action == 'MOVE')){ 
      if(this.universalService.activeRepo == 'main' && this.universalService.currentTab == 'audio' && this.clapprImpl.audioplayer) {
        this.universalService.showMiniPlayer = false;
        this.clapprImpl.pauseAudio();
        this.clapprImpl.audioplayer.stop();
        this.clapprImpl.audioplayer.destroy();
        this.audioStopped = true
      }
      if(this.universalService.activeRepo == 'main' && this.universalService.currentTab == 'audio' && this.universalService.player) {
        this.universalService.showMiniPlayer = false;
        this.universalService.player.pause();
        this.universalService.player.stop();
        this.universalService.player.destroy();
        this.audioStopped = true
      }
      if(!semanticPreviewFromHorizontalPanel)
        await this.universalService.objectsPreviewArray.splice(currentIndex, 1);

      this.objectsForPreview = await this.fetchPreviewArray(); /** fetch data  */
      if(this.universalService.objectsPreviewArray.length == 0){
        this.universalService.showPreview = false
      } else {
        if(currentIndex > this.universalService.objectsPreviewArray.length -1)
          nextIndex=0
        else
          nextIndex=currentIndex
        this.checkVideoClapper();
        this.universalService.selectedFile = this.universalService.objectsPreviewArray[nextIndex];
        if( this.universalService.currentTab != "PrivateFolder" && this.universalService.selectedFile.isFavorite == "Y"){
          this.universalService.selectedFile.isFavorite = true;
        }else if( this.universalService.currentTab != "PrivateFolder" &&  this.universalService.selectedFile.isFavorite == "N"){
          this.universalService.selectedFile.isFavorite = false;
        }
        this.universalService.selectedNodes = [];
        this.universalService.selectedNodes.push(this.universalService.selectedFile)
        this.fileForPreview = this.universalService.objectsPreviewArray[nextIndex];
        this.objectsForPreview = this.universalService.objectsPreviewArray;
        if(this.universalService.objectsPreviewArray.length == 0){
          this.universalService.showPreview = false
        }else{
          setTimeout(() => {
            this.showPreviewModal(this.universalService.objectsPreviewArray[nextIndex])
          }, 1);
          if(this.universalService.userLoggedIn && this.universalService.activeRepo == "main" &&
          (this.fileForPreview["libreOfficeSupported"] || this.fileForPreview["OfficeForWebSupported"])){
            let result = await this.getDocEditURL(this.fileForPreview);
            this.editDocuments(this.fileForPreview,result)
            if(this.universalService.isMobileDevice){
              this.containerHeightCalc.calculateHeight('.docEditFrameCont iframe',null,120)
            }
          }
        }
      }
    }else if(action == 'UNSETFAV' && this.universalService.currentTab == 'Favorites' ){ 
      await this.universalService.objectsPreviewArray.splice(currentIndex, 1);

      this.objectsForPreview = await this.fetchPreviewArray(); /** fetch data  */
      if(this.universalService.objectsPreviewArray.length == 0){
        this.universalService.showPreview = false
      } else {
        if(currentIndex > this.universalService.objectsPreviewArray.length -1)
          nextIndex=0
        else
          nextIndex=currentIndex
        this.checkVideoClapper();
        this.universalService.selectedFile = this.universalService.objectsPreviewArray[nextIndex];
        if(this.universalService.selectedFile.isFavorite == "Y"){
          this.universalService.selectedFile.isFavorite = true;
        }else if(this.universalService.selectedFile.isFavorite == "N"){
          this.universalService.selectedFile.isFavorite = false;
        }
        this.universalService.selectedNodes = [];
        this.universalService.selectedNodes.push(this.universalService.selectedFile)
        this.fileForPreview = this.universalService.objectsPreviewArray[nextIndex];
        this.objectsForPreview = this.universalService.objectsPreviewArray;
        if(this.universalService.objectsPreviewArray.length == 0){
          this.universalService.showPreview = false
        }else{
          this.showPreviewModal(this.universalService.objectsPreviewArray[nextIndex])
          if(this.universalService.userLoggedIn && this.universalService.activeRepo == "main" &&
          (this.fileForPreview["libreOfficeSupported"] || this.fileForPreview["OfficeForWebSupported"])){
            let result = await this.getDocEditURL(this.fileForPreview);
            this.editDocuments(this.fileForPreview,result)
            if(this.universalService.isMobileDevice){
              this.containerHeightCalc.calculateHeight('.docEditFrameCont iframe',null,120)
            }
          }else{
            let el = document.getElementById('frameholder');
            el.classList.add('hide')
          }
        }
      }
    }
  }

  async removeResultsFromPreview(){
    this.objectsForPreview = await this.fetchPreviewArray()
    var nextIndex;
    var currentIndex = this.universalService.selectedPreviewFileIndex-1
    if(currentIndex >= this.objectsForPreview.length -1)
        nextIndex=0
      else
        nextIndex=currentIndex+1
    this.universalService.selectedFile = this.objectsForPreview[nextIndex];
    this.universalService.selectedNodes = [];
    this.universalService.selectedNodes.push(this.universalService.selectedFile)
    this.fileForPreview = this.objectsForPreview[nextIndex];
    if(this.objectsForPreview.length == 0){
      this.universalService.showPreview = false
    }else{
      this.showPreviewModal(this.objectsForPreview[nextIndex]) 
    }
  }

  checkVideoClapper() { /**To stop video clappr If running */
    if(this.universalService.videoClapperRunning){
      AppEvents.videoClapperEvent.next({videoClapperRunning:true})
    }else if(this.universalService.audioClapperRunning){
      AppEvents.videoClapperEvent.next({audioClapperRunning:true})
    }
  }
  openNewAudioInMiniPlayer() {
    var contextMenuRef = this.contextMenuService;
    contextMenuRef.decideContextMenuItemsForDesktop();
    this.universalService.selectedAudioFile = this.universalService.selectedFile
    if(this.universalService.player!=undefined && this.universalService.player!=null){
      this.universalService.player.stop();
      this.universalService.player.destroy();
    }
    this.clapprImpl.openClappr();
    this.universalService.showDirectMiniPlayer = false;
  }
  
  clearAlbumInterval(){
    this.clapprImpl.clearAlbumInterval()

  }

  getLatestPreviewData(file, selectedPreviewFileIndex) {
    var currentFileIndex = selectedPreviewFileIndex -1 ; //when assigned, its added with +1, so should start with 0th position
    var prevFileIndex = currentFileIndex - 1;
    var nextFileIndex = currentFileIndex + 1;
    this.objectsForPreview.forEach((obj, index)=> {
      if (obj['objectKey'] == file.objectKey) {
        //Based on data loaded, take data of previous 2 files (rotational)
        if(prevFileIndex < 0) {
          this.latestPreviewDataArray.push(this.objectsForPreview[this.objectsForPreview.length - 1]);
        } else {
          this.latestPreviewDataArray.push(this.objectsForPreview[index - 1]);
        }

        // //Take data at current index
        this.latestPreviewDataArray.push(this.objectsForPreview[index]);

        //take data of next 2 files
        if(currentFileIndex == (this.objectsForPreview.length - 1)) {
          this.latestPreviewDataArray.push(this.objectsForPreview[0]);
        } else {
          this.latestPreviewDataArray.push(this.objectsForPreview[index + 1]);
        }
      }
    });
  }


  getImageSizeForCaching(file) {
    var availableHeight = window.innerHeight;
    var availableWidth = window.innerWidth;

    if (availableWidth < 767) { //it will be mobile device
      if ((file["height"] == undefined || file["width"] == undefined)) {
        var img = new Image();
        var size = 'n';
        this.webUrl = file["previewTranscodeUrl"];
        this.webUrl = this.webUrl.includes("?") ? this.webUrl + "&" : this.webUrl + "?";
        let type = this.universalService.checkIfImgTypeParamIsRequired(file["mimeSubType"]);
        this.webUrl = this.webUrl + "size=" + size + "&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
        img.src = this.webUrl;
        file["imageUrl"] = this.webUrl;
        img.onload = (event) => {
          file["height"] = img.height;
          file["width"] = img.width;
          var imageDim = this.setPositionForMobileDeviceCaching(file);
          var dimensions = {
            'imageWidth': imageDim.imageWidth,
            'imageHeight': imageDim.imageHeight
          };
          file["imageHeight"] = imageDim.imageHeight;
          file["imageWidth"] = imageDim.imageWidth;
          this.universalService.selectedFile["imageHeight"] = file["imageHeight"];
          this.universalService.selectedFile["imageWidth"] = file["imageWidth"]
          this.getImageUrlForCaching(dimensions, file);
          file["imageUrl"] = this.webUrl;
          this.updateLatestPreviewUrlInCachedArray(file["imageUrl"],file);
          this.universalService.videoPreviewUrl = file;
        };
      } else {
        imageDim = this.setPositionForMobileDeviceCaching(file);
        var dimensions = {
          'imageWidth': imageDim.imageWidth,
          'imageHeight': imageDim.imageHeight
        };
        file["imageHeight"] = imageDim.imageHeight;
        file["imageWidth"] = imageDim.imageWidth;
        this.universalService.selectedFile["imageHeight"] = file["imageHeight"];
        this.universalService.selectedFile["imageWidth"] = file["imageWidth"]
        this.getImageUrlForCaching(dimensions, file);
        file["imageUrl"] = this.webUrl;
        this.universalService.videoPreviewUrl = file;
      } 
    }else {
      if ((file["height"] == undefined || file["width"] == undefined)) {
        var img = new Image();

        var size = 'f';
        this.webUrl = file["previewTranscodeUrl"];
        this.webUrl = this.webUrl.includes("?") ? this.webUrl + "&" : this.webUrl + "?";
        let type = this.universalService.checkIfImgTypeParamIsRequired(file["mimeSubType"]);
        this.webUrl = this.webUrl + "size=" + size + "&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
        img.src = this.webUrl;
        file["imageUrl"] = this.webUrl;
        var imageDim;
        img.onload = (event) => {
          file["height"] = img.height;
          file["width"]= img.width;

          imageDim = this.setPositionForDesktopCaching(file);
          var dimensions = {
            'imageWidth': imageDim.imageWidth,
            'imageHeight': imageDim.imageHeight
          };

          file["imageHeight"] = imageDim.imageHeight;
          file["imageWidth"] = imageDim.imageWidth;
          this.universalService.selectedFile["imageHeight"] = file["imageHeight"];
          this.universalService.selectedFile["imageWidth"] = file["imageWidth"]
          this.getImageUrlForCaching(dimensions, file);
          file["imageUrl"]= this.webUrl;
          this.updateLatestPreviewUrlInCachedArray(file["imageUrl"],file);
          this.universalService.videoPreviewUrl = file;
        };
      } else {
        imageDim = this.setPositionForDesktopCaching(file);
        var dimensions = {
          'imageWidth': imageDim.imageWidth,
          'imageHeight': imageDim.imageHeight
        };
        file["imageHeight"] = imageDim.imageHeight;
        file["imageWidth"] = imageDim.imageWidth;
        this.universalService.selectedFile["imageHeight"] = file["imageHeight"];
        this.universalService.selectedFile["imageWidth"] = file["imageWidth"]
        this.getImageUrlForCaching(dimensions, file);
        file["imageUrl"]= this.webUrl;
        this.universalService.videoPreviewUrl = file;
      }
    }

  }


  updateLatestPreviewUrlInCachedArray(url,object){
    var foundImage = this.cachedImgPreviewDataArray.find(obj=>obj["objectKey"] == object["objectKey"]);
    if(foundImage){
      var index = this.cachedImgPreviewDataArray.indexOf(foundImage);
      if(index>=0){
        this.cachedImgPreviewDataArray[index]["imageHeight"] = object["imageHeight"];
        this.cachedImgPreviewDataArray[index]["imageWidth"] = object["imageWidth"];
        this.cachedImgPreviewDataArray[index]["imageUrl"] = url;
      }
    }
  }

  getImageUrlForCaching(dimensions, file) {
    this.webUrl = file["previewTranscodeUrl"];
    this.webUrl = this.webUrl.includes("?") ? this.webUrl + "&" : this.webUrl + "?";
    let type = this.universalService.checkIfImgTypeParamIsRequired(file["mimeSubType"]);
    if (file["mimeSubType"] != 'gif') {
      this.webUrl = this.webUrl + "size=v&height=" + dimensions.imageHeight * this.displayFactor + "&width=" + dimensions.imageWidth * this.displayFactor + "&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
    }
    if (file["mimeSubType"] == 'gif') {
      this.webUrl = this.webUrl + "apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
    }
    // this.webUrl = this.webUrl.split(".com")[1];
  }


  setPositionForMobileDeviceCaching(file) {
    var orientation = null;
    var rawFile = Object.assign({}, this.fileForPreview);
    var availableHeight = window.innerHeight;
    var availableWidth = window.innerWidth;
    var sizeParameter = undefined;
    var imageHeight = undefined;
    var imageWidth = undefined;
    
    // if (!this.universalService.showJustifiedLayout) {
      if (!rawFile["inverted"] && rawFile.orientation != undefined && (rawFile.orientation.indexOf("90") != -1 || rawFile.orientation.indexOf("270") != -1)) {
        file["width"] = rawFile.height;
        file["height"] = rawFile.width;
        file["inverted"] = true;
      }
    // }

    if (parseInt(file["height"]) > parseInt(file["width"])) { //potrait image
      orientation = "potrait";
      var ratio = file["height"] / file["width"];

      if (file["width"] < availableWidth && file["height"] < availableHeight) {
        if(file["mimeType"]=="video"){
          imageWidth = file["width"];
          imageHeight = availableHeight-120;
          }else{
          imageWidth = file["width"];
          imageHeight = file["height"];
          }
      } else if (file["width"] < availableWidth && file["height"] >= availableHeight) {
        if(file["mimeType"]=="video"){
        imageWidth = file["width"];
        imageHeight = availableHeight-120;
        }else{
        imageWidth = file["width"]
        imageHeight = availableHeight;
        }
      } else {
        if(file["mimeType"]=="video"){
        imageWidth = availableWidth;
        imageHeight = (availableHeight)-120;
        }else{
        imageWidth = availableWidth;
        imageHeight = availableWidth * ratio;
        }
      }

      var remainingWidth = availableWidth - imageWidth;
      var remainingHeight = availableHeight - imageHeight;

      if (remainingHeight < 0) {
        remainingHeight = 0;
      }

      file["top"] = remainingHeight / 2;
      file["left"] = remainingWidth / 2;
      this.universalService.selectedFile["top"] = file["top"];
      this.universalService.selectedFile["left"] = file["left"]

    } else {
      orientation = "landscape";

      var ratio = file["width"] / file["height"];

      if (file["width"] < availableWidth && file["height"] < availableHeight) {
        if(file["mimeType"]=="video"){
          imageWidth = file["width"];
          imageHeight = availableHeight-120;
          }else{
        imageWidth = file["width"];
        imageHeight = file["height"];
          }
      } else if (file["width"] < availableWidth && file["height"] >= availableHeight) {
        if(file["mimeType"]=="video"){
          imageWidth = file["width"];
          imageHeight = availableHeight-120;
          }else{
        imageWidth = file["width"];
        imageHeight = availableHeight;
          }
      } else {
        // if(file["mimeType"]=="video"){
        //   imageWidth = file["width"];
        //   imageHeight = availableHeight-120;
        //   }else{
          imageWidth = availableWidth;
          imageHeight = imageWidth / ratio;
          // }
      }

      var remainingWidth = availableWidth - imageWidth;
      var remainingHeight = availableHeight - imageHeight;

      file["top"] = remainingHeight / 2;
      file["left"] = remainingWidth / 2;
      this.universalService.selectedFile["top"] = file["top"];
      this.universalService.selectedFile["left"] = file["left"]
    }
    return {
      "imageWidth": Math.round(imageWidth),
      "imageHeight": Math.round(imageHeight)
    };
  };

  setPositionForDesktopCaching(file) {
    var orientation = null;
    var rawFile = Object.assign({}, file);
    var availableHeight = window.innerHeight;
    var availableWidth = window.innerWidth;
    var sizeParameter = undefined;
    var imageHeight = undefined;
    var imageWidth = undefined;


    // if(!this.universalService.showJustifiedLayout){
      if (!rawFile["inverted"] && rawFile.orientation != undefined && (rawFile.orientation.indexOf("90") != -1 || rawFile.orientation.indexOf("270") != -1)) {
        file["width"] = rawFile.height;
        file["height"] = rawFile.width;
        file["inverted"] = true
      }
    // }
    

    if (parseInt(file["height"]) > parseInt(file["width"])) { //potrait image
      orientation = "potrait";
      var ratio = file["height"] / file["width"];
      if (file["height"] < availableHeight && file["width"] < availableWidth) {
        if(file["mimeType"]=="video"){
          imageHeight = availableHeight-120;
          imageWidth = imageHeight / ratio;
        }else{
        imageWidth = file["width"];
        imageHeight = file["height"];
        }
      } else if (file["height"] >= availableHeight) {
        if(file["mimeType"]=="video"){
          imageHeight = availableHeight-120;
          imageWidth = imageHeight / ratio;
        }else{
          imageHeight = availableHeight;
          imageWidth = imageHeight / ratio;
        }
      }
      var remainingWidth = availableWidth - imageWidth;
      var remainingHeight = availableHeight - imageHeight;

      file["top"] = remainingHeight / 2;
      file["left"] = remainingWidth / 2;
      this.universalService.selectedFile["top"] = file["top"];
      this.universalService.selectedFile["left"] = file["left"]
    } else {
      orientation = "landscape";

      var ratio = file["width"] / file["height"];

      if (file["width"] < availableWidth && file["height"] < availableHeight) {
        if(file["mimeType"]=="video"){
          imageHeight = availableHeight-120;
          imageWidth = imageHeight * ratio;
        }
        else{
        imageWidth = file["width"];
        imageHeight = file["height"];
        }
      } else if (file["height"] > availableHeight) {
        if(file["mimeType"]=="video"){
        imageHeight = availableHeight-120;
        imageWidth = imageHeight * ratio;
        }else{
        imageHeight = availableHeight;
        imageWidth = imageHeight * ratio;
        }
      } else {
        if(file["mimeType"]=="video" && file["height"] == availableHeight){
        imageWidth = availableWidth;
        imageHeight = (imageWidth / ratio)-120;
        }else{
        imageWidth = availableWidth;
        imageHeight = imageWidth / ratio;
        }
      }
      
      var remainingWidth = availableWidth - imageWidth;
      var remainingHeight = availableHeight - imageHeight;
      

      file["top"] = remainingHeight / 2;
      file["left"] = remainingWidth / 2;
      this.universalService.selectedFile["top"] = file["top"];
      this.universalService.selectedFile["left"] = file["left"];

    }
    return {
      "imageWidth": Math.round(imageWidth),
      "imageHeight": Math.round(imageHeight)
    };
  }


  checkIfEnableCaching(file) {
    this.objectsForPreview.forEach((obj, index)=> {
      if(obj['objectKey'] == file.objectKey){
        
        if(this.objectsForPreview[index-1]){
          this.objectsForPreview[index-1]["mimeType"]=='image'?this.latestPreviewDataArray.push(this.objectsForPreview[index-1]):"";
        }else {
          this.objectsForPreview[this.objectsForPreview.length-1]["mimeType"]=='image'?this.latestPreviewDataArray.push(this.objectsForPreview[this.objectsForPreview.length-1]):"";
        }

        this.objectsForPreview[index]["mimeType"]=='image'?this.latestPreviewDataArray.push(this.objectsForPreview[index]):"";

        if(this.objectsForPreview[index+1]){
          this.objectsForPreview[index+1]["mimeType"]=='image'?this.latestPreviewDataArray.push(this.objectsForPreview[index+1]):"";
        }else {
          this.objectsForPreview[0]["mimeType"]=='image'?this.latestPreviewDataArray.push(this.objectsForPreview[0]):"";
        }
      }
    });
    //remove duplicate - above code is adding prev & next records in array event if it has 1 obj in objectsForPreview

    if(this.latestPreviewDataArray.length > 1) {
      this.latestPreviewDataArray = Array.from(new Set(this.latestPreviewDataArray)); 
    }
    this.cacheObjects();
  }


  cacheObjects(){
        //CACHE PREVIEW
        if (this.cachedImgPreviewDataArray.length === 0) {
          this.isNewCache = true;
        } else {
          this.isNewCache = false;
        }
        this.latestPreviewDataArray.forEach((item, index)=> {
          this.getImageSizeForCaching(item);
          this.latestPreviewImageUrls.push({
            objectKey: item.objectKey,
            imageUrl: item.imageUrl,
            objectName : item.objectName,
            isCurrentImage: (item.objectKey === this.fileForPreview.objectKey ? true : false),
            isPreviewedImage: (item.objectKey === this.fileForPreview.objectKey ? true : null),
            top: item.top,
            imageHeight: item.imageHeight,
            imageWidth: item.imageWidth
          });
          if (this.isNewCache === false) {
              this.cachedImgPreviewDataArray.forEach((cacheItem, cacheIndex)=> { 
              cacheItem.isCurrentImage = false;
              if (cacheItem.objectKey != item.objectKey && cacheItem.isPreviewedImage != true) {
                this.cachedImgPreviewDataArray.splice(cacheIndex, 1);
              }
            });
          }
        });
        if (this.isNewCache === true) {
          this.cachedImgPreviewDataArray = this.latestPreviewImageUrls;
        } else {
          var tempArray = [];
          this.latestPreviewImageUrls.map(url=>{
            var findAlreadyExists = this.cachedImgPreviewDataArray.find(cItem => cItem["objectKey"] == url["objectKey"]);
            if(!findAlreadyExists){
              tempArray.push(url)
            }
          })
          var cachedArray = this.cachedImgPreviewDataArray.concat(tempArray);
          cachedArray.map(cItem=>{
            if(cItem["objectKey"] == this.fileForPreview.objectKey){
              cItem["isCurrentImage"] = true;
              cItem["isPreviewedImage"] = true;
            }else{
              cItem["isCurrentImage"] = false;
            }
          })
          this.cachedImgPreviewDataArray = cachedArray;
          // var urlDataArray = this.cachedImgPreviewDataArray.concat(this.latestPreviewImageUrls);
          // var tempArr = [];
          // this.cachedImgPreviewDataArray = urlDataArray.filter(function(elem) {
          //   if (tempArr.indexOf(elem.objectKey) === -1 || elem.isCurrentImage === true) {
          //     // If not present in array, then add it
          //     tempArr.push(elem.objectKey);
          //     return true;
          //   } else {
          //     // Already present in array, don't add it
          //     return false;
          //   }
          // });
        }
        this.latestPreviewDataArray = [];
        //CACHE PREVIEW END
  }

  async getDocEditURL(object,defaultPreview=true){
    let objectDC = object["objectDC"] ? object["objectDC"].toUpperCase() : this.localStorageService.getDCGroupCode(true);
    let allDCUrls = APP_SETTINGS["SETTINGS"];
    let dcURLs = allDCUrls["dcUrls"].filter(function(settings){
      return settings.dcGroupCode.toLowerCase() == objectDC.toLowerCase();
    });
    dcURLs = dcURLs[0];
    let action =''
    var url;
    if(object["OfficeForWebSupported"] && !defaultPreview){
      if(object["MSDocEditAllowed"]){
        action = "edit";
      }else{
        action = "view";
      } 
    }else{
      action = "view";
    }
    // if(object["version"] != object["latestVersion"]){ // this check is added to pass the action as view, if user is trying to preview a specific version of a document other than latest version
    //   action = "view";
    // }
    
    if(object["boardKey"]){
      if(object["OfficeForWebSupported"] && ENV_CONSTANTS["constants"]["enableOfficeForWebPreview"] && !defaultPreview){
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["baseDCURL"] + ENV_CONFIG["commonUrls"]["MSdocEditUrl"] + object.objectKey + "?action=" + action +  "&boardKey=" + object.boardKey + "&version=" + (object["version"]?object["version"]:1).toString();
      }else{
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["baseDCURL"] + "/document/edit/auth/" + object.objectKey + "?boardKey=" + object.boardKey+ "&action=" + action + "&version=" + (object["version"]?object["version"]:1).toString();
      }
    } else if(object["tfKey"]){
      if(object["OfficeForWebSupported"] && ENV_CONSTANTS["constants"]["enableOfficeForWebPreview"] && !defaultPreview){
        url = dcURLs["baseDCURL"] + ENV_CONFIG["commonUrls"]["MSdocEditUrl"] + object.objectKey + "?action=" + action + "&tfKey=" + object.tfKey + "&version=" + (object["version"]?object["version"]:1).toString() + (object["valMetadataDc"] ?  "&vdc=" + object["valMetadataDc"] : "");
      }else{
        url = dcURLs["baseDCURL"] + "/document/edit/auth/" + object.objectKey + "?action=" + action + "&tfKey=" + object.tfKey + "&version=" + (object["version"]?object["version"]:1).toString() + (object["valMetadataDc"] ?  "&vdc=" + object["valMetadataDc"] : "");
      }
    } else if(object["shareType"] == "R"){
      if(object["OfficeForWebSupported"] && ENV_CONSTANTS["constants"]["enableOfficeForWebPreview"] && !defaultPreview){
        url = dcURLs["baseDCURL"] + ENV_CONFIG["commonUrls"]["MSdocEditUrl"] + object.objectKey + "?action=" + action + "&shareKey=" + object.shareKey + "&version=" + (object["version"]?object["version"]:1).toString() + (object["valMetadataDc"] ?  "&vdc=" + object["valMetadataDc"] : "");
      }else{
        url = dcURLs["baseDCURL"] + "/document/edit/auth/" + object.objectKey + "?action=" + action + "&shareKey=" + object.shareKey + "&version=" + (object["version"]?object["version"]:1).toString() + (object["valMetadataDc"] ?  "&vdc=" + object["valMetadataDc"] : "");
      }
    } else{
      if(object["OfficeForWebSupported"] && ENV_CONSTANTS["constants"]["enableOfficeForWebPreview"] && !defaultPreview){
        url = dcURLs["baseDCURL"] + ENV_CONFIG["commonUrls"]["MSdocEditUrl"] + object.objectKey + "?action=" + action + "&version=" + (object["version"]?object["version"]:1).toString() + (object["valMetadataDc"] ?  "&vdc=" + object["valMetadataDc"] : "");
      }else{
        if(this.universalService.currentTab == "PrivateFolder"){
          this.universalService.isPrivateFolderTokenRequired = true ;
          await this.listService.getPPFToken();    
        }
        url = dcURLs["baseDCURL"] + "/document/edit/auth/" + object.objectKey + "?action=" + action + "&version=" + (object["version"]?object["version"]:1).toString() + (object["valMetadataDc"] ?  "&vdc=" + object["valMetadataDc"] : "");
      }
    }
    if(object["showLatestVersion"]){ // removing the version param from the request URL if user is not previewing a specific version inorder to render the latest content if user has updated the document from office for web
      var queryParams = new URL(url);
      var search_params = queryParams.searchParams;
      search_params.delete("version");
      queryParams.search = search_params.toString();
      url = queryParams.toString();
    }
    
    try{
      var result =  await  this.fetchDocAuthURL(url);
      return result;
    }catch(exc){
      console.log("exception in doc edit",exc);
      return exc;
    }
  }

  fetchDocAuthURL(url){
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.get(url).subscribe(
        async suc => {
          resolve(suc) ;
        },
        err => {
          self.universalService.showErrorMessage(err);
          reject(err);
        }
      )
    })
  }

  clearPreviewCache(){
    this.cachedImgPreviewDataArray = [];
  }


  getObjectMetadataForPreview(objectDetails){
    let metadataURL = this.getModuleType(objectDetails["locationOfUpload"],objectDetails);
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.get(metadataURL).subscribe(
          info=>{
                resolve(info)
          },
          err=>{
                console.log('obj metadata err',err);
                if(err["error"]["code"] == "BRSOM0027"){
                  reject(err);
                }else{
                  reject(null)
                }
          }
        )
    })
  }


  getModuleType(locationOfUpload,objectDetails){
    switch(locationOfUpload){
      case 'teamfolders':
        return ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["teamFolderMetadata"] + "/" + objectDetails["objectKey"] + "/info?tfKey=" + objectDetails["tfKey"];
      case 'album':
        return ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + ENV_CONFIG.commonUrls["boardObjectMetadata"] + objectDetails["objectKey"] + "/info?boardKey=" + objectDetails["boardKey"];
      case 'sharedbyme':
      case 'sharedwithme':
        return ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShare"] + ENV_CONFIG.commonUrls["metaData"] + "/" + objectDetails["objectKey"] + "/info?shareKey=" + objectDetails["shareKey"];
      case 'allfiles':
      case 'PrivateFolder':
        return ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nmsMetaData"] + "/" + objectDetails["objectKey"] + "/info";
      default:
        console.log("file is of unsupported module",locationOfUpload)
    }
  }

}  